import React from 'react'
import Contact from '../public/Contact'
import ManuOperation from './navOperationRoom/ManuOperation'

function ContactLaboratory() {
    return (
        <div>
            <ManuOperation menuActive={'contact'}/>
            <Contact disabledMenu />
        </div>
    )
}

export default ContactLaboratory